import apiClient from './apiClient';

export interface FlipLeg {
  have: string;
  want: string;
  haveQty: number;
  wantQty: number;
  spent: number;
  received: number;
  cancelled?: boolean;
  measured?: boolean;
  durationMs?: number;
}

export interface Flip {
  id: string;
  characterId: string;
  characterName: string;
  result: string;
  reason: string;
  flippedAt: string;
  cycleId: string | null;
  source: string;
  commitQty: number;
  sourceSpent: number;
  sourceRecovered: number;
  netSource: number;
  goldSpent: number;
  chaosRate: number;
  expectedGross: number | null;
  expectedNet: number | null;
  expectedGold: number | null;
  durationMs: number;
  path: string[] | null;
  legs: FlipLeg[] | null;
}

/**
 * Fetches completed flips for the authenticated user's characters.
 * The backend /flips endpoint filters by owner based on JWT.
 */
export const getFlips = async (): Promise<Flip[]> => {
  const response = await apiClient.get('/flips');
  return response.data;
};
